import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'https://koreanmanhwa.com/',
    description: '免费漫画大全，好看韩漫推荐，无遮挡下拉式阅读模式确保在线体验舒适流畅，让您专注于漫画情节本身。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://koreanmanhwa.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'https://koreanmanhwa.com/',
    description: '专业韩国漫画在线阅读平台，提供免费漫画大全和好看的韩国漫画推荐。',
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩国漫画网 - 免费漫画大全 - 好看的韩国漫画推荐',
    description: '免费漫画大全，好看韩漫推荐，无遮挡下拉式阅读模式确保在线体验舒适流畅。',
    url: 'https://koreanmanhwa.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://koreanmanhwa.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <PopularComics />
            <LatestUpdates />
            <FAQSection />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}